export default __webpack_public_path__ + "static/media/bg_visa_08.877eb6ff.jpg";